import { backendProvider } from '../backend';
import { getCoreHttpBaseUrl } from './coreConfig';

export class CoreApiError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

interface CoreFetchOptions {
  method?: 'GET' | 'POST' | 'DELETE';
  body?: unknown;
}

// Auth failures return `{ error: "unauthorized" }` (a plain string); every
// other error returns `{ error: { code, message } }` (an object) — by design,
// not something to normalize server-side.
const extractErrorMessage = (body: any, fallback: string): string => {
  if (!body || !body.error) return fallback;
  return typeof body.error === 'string' ? body.error : body.error?.message || fallback;
};

export const coreFetch = async <T>(path: string, options: CoreFetchOptions = {}): Promise<T> => {
  const jwt = await backendProvider.auth.getIdToken();
  const response = await fetch(`${getCoreHttpBaseUrl()}${path}`, {
    method: options.method || 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${jwt}`,
    },
    body: options.body !== undefined ? JSON.stringify(options.body) : undefined,
  });

  if (response.status === 204) {
    return undefined as T;
  }

  const data = await response.json().catch(() => null);

  if (!response.ok) {
    throw new CoreApiError(extractErrorMessage(data, `Core request failed (${response.status})`), response.status);
  }

  return data as T;
};
